export const SIGNUP_CLIENT = "signup:client"